import { css } from '@linaria/core';

export const voyagerRootVars = css`
  :global() {
    :root {
      --voyager-color-primary: #85a2aa;
      --voyager-color-secondary: #455b61;
      --voyager-color-tertiary: #b5d3dc;
      --voyager-color-fontPrimary: #444444;
      --voyager-color-fontSecondary: #666666;
      --voyager-color-navigationAndFooter: #333333;
      --voyager-color-header: #f4f4f4;
      --voyager-color-sectionTitle: #919191;
      --voyager-color-borderGrey: #e0e0e0;
      --voyager-color-borderGreyLighter: #efefef;
      --voyager-color-darkGrey: #646464;
      --voyager-color-grey: #c1c1c1;
      --voyager-color-lightGrey: #e2e2e2;
      --voyager-color-lighterGrey: #f7f7f7;
      --voyager-color-error: #e55646;
      --voyager-color-errorBackground: #fdeeeb;
      --voyager-color-success: #009688;
      --voyager-color-successBackground: #e5f4f3;
      --voyager-color-info: #01579b;
      --voyager-color-infoBackground: #e6eef5;
      --voyager-color-black: #000000;
      --voyager-color-white: #ffffff;
      --voyager-color-offWhite: #f1f1f1;
      --voyager-color-sale: #e2363f;
      --voyager-heading-font: 'Playfair Display', serif;
      --voyager-body-font: 'Open Sans', sans-serif;
    }
  }
`;
